import { ShieldCheck, Sparkles } from "lucide-react";
import { PdfButton } from "@/components/program/ExportButtons";
import { kerangkaText } from "@/lib/program";

const Block = ({ title, children, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    <div className="eyebrow">{title}</div>
    {children}
  </div>
);

export const TrainingPlan = ({ kajian }) => {
  const d = kajian.current;
  const l = d.latihan;
  return (
    <section className="space-y-6" data-testid="training-plan">
      <div className="flex justify-end"><PdfButton kajianId={kajian.id} tajuk="Kerangka Program" teks={kerangkaText(kajian)} label="PDF Kerangka Program" testid="kerangka-pdf-button" /></div>
      <div className="rounded-2xl border border-line p-5 sm:p-6 space-y-3" data-testid="verified-evidence">
        <div className="flex items-center gap-2 text-sm font-semibold text-i"><ShieldCheck size={16} /> Dalil disahkan — teks daripada pangkalan data</div>
        <div className="font-display text-lg text-ink">{d.rujukan}</div>
        <p className="arabic-sm text-lg text-ink text-right" lang="ar" dir="rtl">{d.arab}</p>
        <p className="text-sm text-ink/90 leading-relaxed">{d.terjemahan}</p>
        <p className="text-xs text-mute font-mono-data">Terjemahan: Abdullah Muhammad Basmeih. Rujukan ayat berkaitan disemak terhadap pangkalan data. Pandangan mufassir dirumus daripada petikan 8 kitab tafsir.</p>
      </div>
      <div className="surface rounded-2xl p-5 sm:p-6 space-y-6">
        <div className="flex items-center gap-2 text-sm font-semibold text-q"><Sparkles size={16} /> Analisis & cadangan AI — semak dan sesuaikan sebelum digunakan</div>
        <Block title="Analisis keperluan peserta" testid="plan-analisis"><p className="text-sm text-ink leading-relaxed">{l.analisis_keperluan}</p></Block>
        <Block title="Objektif pembelajaran" testid="plan-objektif"><ol className="list-decimal pl-5 space-y-1 text-sm text-ink">{l.objektif.map((x, i) => <li key={i}>{x}</li>)}</ol></Block>
        <Block title="Rangka kandungan" testid="plan-kandungan">
          <div className="grid md:grid-cols-2 gap-3">
            {l.rangka_kandungan.map((s, i) => (
              <div key={i} className="rounded-xl border border-line p-4">
                <div className="flex justify-between gap-2 text-xs font-mono-data text-mute"><span>Sesi {i + 1} · {s.masa}</span><span className={`text-${(s.lapis || "q").toLowerCase()[0]}`}>{s.lapis}</span></div>
                <div className="font-display text-base text-ink mt-1">{s.sesi}</div>
                <ul className="list-disc pl-5 text-sm text-ink/90 mt-2 space-y-0.5">{s.isi.map((x, j) => <li key={j}>{x}</li>)}</ul>
              </div>
            ))}
          </div>
        </Block>
        <Block title="Aktiviti interaktif" testid="plan-aktiviti">
          <ul className="space-y-2 text-sm text-ink">{l.aktiviti.map((a, i) => <li key={i}><strong>{a.nama}</strong> <span className="text-mute">({a.masa}, {a.kaedah})</span></li>)}</ul>
        </Block>
        <Block title="Soalan refleksi" testid="plan-refleksi"><ol className="list-decimal pl-5 space-y-1 text-sm text-ink">{l.soalan_refleksi.map((x, i) => <li key={i}>{x}</li>)}</ol></Block>
        <Block title="Tindakan selepas program" testid="plan-tindakan"><ul className="list-disc pl-5 space-y-1 text-sm text-ink">{l.tindakan_selepas.map((x, i) => <li key={i}>{x}</li>)}</ul></Block>
      </div>
    </section>
  );
};
